(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  /*
    <wk-horaires> — etat d'ouverture du service client, calcule cote client.

    Pourquoi pas en Liquid : les pages sont mises en cache par le CDN, une heure
    calculee au rendu serait fausse pour le visiteur suivant.

    Le fuseau est force sur Europe/Paris : sinon un client a La Reunion verrait
    « ouvert » a 3 h du matin heure de Guer.

    Horaires ci-dessous, en minutes depuis minuit (0 = dimanche).
  */
  class WkHoraires extends HTMLElement {
    static SEMAINE = {
      1: [[480, 720], [780, 960]],   // lundi    8h-12h / 13h-16h
      2: [[480, 720], [780, 960]],   // mardi    8h-12h / 13h-16h
      3: [[480, 720], [780, 960]],   // mercredi 8h-12h / 13h-16h
      4: [[480, 720], [780, 960]],   // jeudi    8h-12h / 13h-16h
      5: [[480, 720], [780, 900]],   // vendredi 8h-12h / 13h-15h
      6: [],                         // samedi   ferme
      0: []                          // dimanche ferme
    };

    static JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];

    connectedCallback() {
      try {
        this.rendre();
        this.minuteur = setInterval(() => this.rendre(), 60000);
      } catch (e) {
        /* Le repli deja present dans le HTML reste affiche. */
      }
    }

    disconnectedCallback() { clearInterval(this.minuteur); }

    static maintenantParis() {
      const fmt = new Intl.DateTimeFormat('fr-FR', {
        timeZone: 'Europe/Paris', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false
      });
      const p = Object.fromEntries(fmt.formatToParts(new Date()).map((x) => [x.type, x.value]));
      const jours = { dim: 0, lun: 1, mar: 2, mer: 3, jeu: 4, ven: 5, sam: 6 };
      return {
        jour: jours[p.weekday.toLowerCase().slice(0, 3)],
        minutes: parseInt(p.hour, 10) * 60 + parseInt(p.minute, 10)
      };
    }

    static formater(minutes) {
      const h = Math.floor(minutes / 60);
      const m = minutes % 60;
      return m === 0 ? h + 'h' : h + 'h' + String(m).padStart(2, '0');
    }

    static prochaine(jour, minutes) {
      for (let i = 0; i < 8; i += 1) {
        const j = (jour + i) % 7;
        const plages = WkHoraires.SEMAINE[j] || [];
        for (let k = 0; k < plages.length; k += 1) {
          const debut = plages[k][0];
          if (i > 0 || debut > minutes) {
            let quand;
            if (i === 0) quand = 'aujourd\u2019hui';
            else if (i === 1) quand = 'demain';
            else quand = WkHoraires.JOURS[j];
            return quand + ' \u00e0 ' + WkHoraires.formater(debut);
          }
        }
      }
      return null;
    }

    rendre() {
      const now = WkHoraires.maintenantParis();
      const plages = WkHoraires.SEMAINE[now.jour] || [];
      let courante = null;
      for (let i = 0; i < plages.length; i += 1) {
        if (now.minutes >= plages[i][0] && now.minutes < plages[i][1]) { courante = plages[i]; break; }
      }

      let etat; let detail;
      if (courante) {
        etat = 'Ouvert';
        detail = 'Jusqu\u2019\u00e0 ' + WkHoraires.formater(courante[1]);
      } else {
        etat = 'Ferm\u00e9';
        const suite = WkHoraires.prochaine(now.jour, now.minutes);
        detail = suite ? 'Ouvre ' + suite : '';
      }

      this.classList.toggle('wk-horaires--ouvert', Boolean(courante));
      this.innerHTML =
        '<span class="wk-horaires__etat"><span class="wk-horaires__pastille"></span>' + etat + '</span>' +
        (detail ? '<p class="wk-horaires__detail">' + detail + '</p>' : '');
    }
  }

  if (!customElements.get('wk-horaires')) { customElements.define('wk-horaires', WkHoraires); }

  /*
    Defilement automatique de la bande de reassurance, sur mobile uniquement.

    Sur ordinateur la grille montre tout d'un coup : rien a faire. En dessous
    du point de rupture, un seul bloc tient a l'ecran, et sans rotation les
    logos places apres le deuxieme ne seraient jamais vus.

    Le defilement s'arrete des que le visiteur touche la bande — reprendre la
    main sur quelqu'un qui fait defiler lui-meme est le defaut classique de ce
    genre de composant. Il s'arrete aussi quand l'onglet passe en arriere-plan,
    et ne demarre pas du tout si la personne a demande a reduire les animations.
  */
  (function () {
    var bande = document.querySelector('.wk-footer__preuves');
    var cadre = document.querySelector('.wk-carrousel');
    if (!bande || !cadre) return;

    var prec = cadre.querySelector('.wk-carrousel__fleche--prec');
    var suiv = cadre.querySelector('.wk-carrousel__fleche--suiv');
    var points = cadre.querySelector('.wk-carrousel__points');
    var sobre = window.matchMedia('(prefers-reduced-motion: reduce)');
    var minuteur = null;
    var fige = false;
    // Reglee dans le Personnalisateur ; 0 desactive la rotation sans retirer
    // les fleches ni les points.
    var vitesse = parseInt(cadre.getAttribute('data-vitesse'), 10);
    if (isNaN(vitesse)) vitesse = 5;

    // Rien ne defile tant que la bande tient a l'ecran : sur grand ecran les
    // logos sont tous visibles et des commandes n'auraient aucun sens.
    function deborde() {
      return bande.scrollWidth > bande.clientWidth + 4;
    }

    function nbPages() {
      return Math.max(1, Math.ceil(bande.scrollWidth / bande.clientWidth));
    }

    function pageCourante() {
      return Math.round(bande.scrollLeft / bande.clientWidth);
    }

    function allerA(page) {
      bande.scrollTo({ left: page * bande.clientWidth, behavior: 'smooth' });
    }

    function construirePoints() {
      points.innerHTML = '';
      if (!deborde()) return;
      for (var i = 0; i < nbPages(); i += 1) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'wk-carrousel__point';
        b.setAttribute('aria-label', 'Page ' + (i + 1));
        (function (n) {
          b.addEventListener('click', function () { fige = true; arreter(); allerA(n); });
        })(i);
        points.appendChild(b);
      }
    }

    function rafraichir() {
      var actif = deborde();
      cadre.classList.toggle('est-defilante', actif);
      bande.classList.toggle('est-entiere', !actif);
      if (!actif) return;

      var p = pageCourante();
      prec.disabled = bande.scrollLeft <= 4;
      suiv.disabled = bande.scrollLeft >= bande.scrollWidth - bande.clientWidth - 4;

      var liste = points.children;
      for (var i = 0; i < liste.length; i += 1) {
        liste[i].classList.toggle('est-actif', i === p);
      }
    }

    function avancer() {
      if (fige || document.hidden || !deborde()) return;
      var p = pageCourante() + 1;
      if (p >= nbPages()) p = 0;   // retour au debut
      allerA(p);
    }

    function demarrer() {
      arreter();
      construirePoints();
      rafraichir();
      if (sobre.matches || fige || vitesse === 0 || !deborde()) return;
      minuteur = setInterval(avancer, vitesse * 1000);
    }

    function arreter() {
      if (minuteur) { clearInterval(minuteur); minuteur = null; }
    }

    prec.addEventListener('click', function () {
      fige = true; arreter(); allerA(Math.max(0, pageCourante() - 1));
    });
    suiv.addEventListener('click', function () {
      fige = true; arreter(); allerA(Math.min(nbPages() - 1, pageCourante() + 1));
    });

    // Le geste du visiteur prime : la rotation s'arrete des qu'il prend la main.
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (evt) {
      bande.addEventListener(evt, function () { fige = true; arreter(); }, { passive: true });
    });

    bande.addEventListener('scroll', rafraichir, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) arreter(); else demarrer();
    });

    window.addEventListener('resize', demarrer);
    document.addEventListener('shopify:section:load', demarrer);
    demarrer();
  })();

  /*
    Repli des colonnes du footer.

    Le CSS ne suffit pas : Chrome masque le contenu d'un <details> replie via
    un pseudo-element interne qu'une regle sur l'enfant ne touche pas. On pilote
    donc l'attribut `open` lui-meme — replie sur mobile, deplie au-dela du point
    de rupture, ou le chevron est masque et le summary rendu inerte.
  */
  (function () {
    var seuil = window.matchMedia('(min-width: 900px)');

    function appliquer() {
      var cols = document.querySelectorAll('.wk-footer__col > details, .wk-footer__legal-repli');
      for (var i = 0; i < cols.length; i += 1) {
        if (seuil.matches) {
          cols[i].setAttribute('open', '');
        } else {
          cols[i].removeAttribute('open');
        }
      }
    }

    appliquer();
    if (seuil.addEventListener) {
      seuil.addEventListener('change', appliquer);
    } else if (seuil.addListener) {
      seuil.addListener(appliquer);
    }
    // Le Personnalisateur recharge la section apres coup.
    document.addEventListener('shopify:section:load', appliquer);
  })();

  } catch(e) { console.error(e); }
})();
})();
